import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "comments__profile-picture-container"
}
const _hoisted_2 = { class: "comments__comment-container" }
const _hoisted_3 = { class: "comments__comment-metadata" }
const _hoisted_4 = { class: "comments__comment-name" }
const _hoisted_5 = { class: "comments__comment-time" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "comments__image-attachments"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 3,
  class: "comments__files-pending"
}
const _hoisted_13 = {
  key: 4,
  class: "comments__links"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  lass: "comments comments--no-content"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " No comments yet. ", -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProfilePictureComponent = _resolveComponent("ProfilePictureComponent")
  const _component_GalleryModalComponent = _resolveComponent("GalleryModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "ul",
      class: _normalizeClass(["comments", { 'comments--discussion': $props.commentType === 'discussion' }])
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.comments, (comment) => {
          return (_openBlock(), _createElementBlock("li", {
            key: comment.id,
            class: "comments__comment"
          }, [
            ($props.commentType === 'discussion')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_ProfilePictureComponent, {
                    user: comment.author
                  }, null, 8 /* PROPS */, ["user"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(comment.author.fullName), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_5, _toDisplayString($options.getTimepassedLabel( comment.postDate )), 1 /* TEXT */)
              ]),
              _createCommentVNode(" eslint-disable vue/no-v-html "),
              _createElementVNode("div", {
                class: "comments__comment-content typeset typeset--small",
                innerHTML: comment.comment_content
              }, null, 8 /* PROPS */, _hoisted_6),
              ($props.showTags && comment.video_timestamp)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "comment__timestamp",
                    onClick: $event => ($options.flashVideoFrame( comment.video_timestamp ))
                  }, _toDisplayString($options.formatTimestamp( comment.video_timestamp )), 9 /* TEXT, PROPS */, _hoisted_7))
                : _createCommentVNode("v-if", true),
              ($props.showTags && comment.position_x)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "comment__tour-comment",
                    onClick: $event => ($options.selectComment( comment ))
                  }, " Tour ", 8 /* PROPS */, _hoisted_8))
                : _createCommentVNode("v-if", true),
              ($options.getImages( comment.comment_attachments ).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getImages( comment.comment_attachments ), (attachment, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: `${comment.id}-image-attachment-${index}`,
                        class: "comments__image-attachment-thumbnail",
                        onClick: $event => ($options.setActiveAttachments( comment.comment_attachments, attachment ))
                      }, [
                        _createElementVNode("img", {
                          class: "comments__image-attachment",
                          src: attachment.attachment_thumbnail_url
                        }, null, 8 /* PROPS */, _hoisted_11)
                      ], 8 /* PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.filesPending( comment ) > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($options.filesPending( comment )) + " attachment(s) processing ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (comment.comment_attachments.length > 1 || $options.getFiles( comment.comment_attachments ).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getFiles( comment.comment_attachments ), (attachment, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: `${comment.id}-image-attachment-${index}`,
                        class: "comments__file-attachment",
                        href: attachment.attachment_url,
                        target: "_blank"
                      }, _toDisplayString(attachment.attachment_filename), 9 /* TEXT, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (comment.comment_attachments.length > 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: _normalizeClass(["comments__file-attachment comments__file-attachment--download-all", { 'comments__file-attachment--loading ': $data.loading_attachments === comment.id }]),
                          onClick: $event => ($options.downloadAllAttachments( comment ))
                        }, " Download all attachments ", 10 /* CLASS, PROPS */, _hoisted_15))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"]),
    (!$props.comments || !$props.comments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", {
            class: _normalizeClass(["comments__comment-content comments__comment-content--no-content typeset typeset--small", { 'comments__comment-content--empty-discussion': $props.commentType === 'discussion' }])
          }, _hoisted_18, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.active_attachments && $data.active_attachments.length && $data.show_attachment_modal)
            ? (_openBlock(), _createBlock(_component_GalleryModalComponent, {
                key: 0,
                options: $data.active_attachments,
                config: { downloadable: true },
                onCloseModal: $options.closeAttachmentModal
              }, null, 8 /* PROPS */, ["options", "onCloseModal"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}